import PropTypes from "prop-types";
import React from "react";

import { ViewDeleteIcon } from "../../utils/Icons";
import "./ViewDeleteButton.scss";

const ViewDeleteButton = ({
  containerClassName,
  className,
  onClick
}) => {
  return (
    <div
      className={`${containerClassName} delete-btn`}
      onClick={onClick}>
      <ViewDeleteIcon
        className={`table-icon action-icon  ${className}`}
      />
    </div>
  );
};

ViewDeleteButton.propTypes = {
  containerClassName: PropTypes.string,
  className: PropTypes.string,
  onClick: PropTypes.func
};

export default ViewDeleteButton;
